export interface ServicePlace {
  name: string;
  slug?: string;
}

export interface CityPageData {
  slug: string;
  name: string;
  title: string;
  intro: string;
}

export const servicePlaces: ServicePlace[] = [
  { name: 'Twin Cities', slug: 'twin-cities' },
  { name: 'Minneapolis', slug: 'minneapolis' },
  { name: 'St. Paul', slug: 'st-paul' },
  { name: 'Bloomington' },
  { name: 'Golden Valley', slug: 'golden-valley' },
  { name: 'St. Cloud', slug: 'st-cloud' },
  { name: 'Rochester', slug: 'rochester' },
  { name: 'Byron' },
  { name: 'Kasson' },
  { name: 'Stewartville' },
  { name: 'Owatonna' },
  { name: 'Winona' },
  { name: 'Mankato' },
  { name: 'Duluth' },
  { name: 'Eden Prairie' },
  { name: 'Edina' },
  { name: 'Minnetonka' },
  { name: 'Plymouth' },
  { name: 'Maple Grove' },
  { name: 'Woodbury' },
  { name: 'Eagan' },
  { name: 'Burnsville' },
  { name: 'Apple Valley' },
  { name: 'Lakeville' },
  { name: 'Roseville' },
  { name: 'Brooklyn Park' },
  { name: 'Austin' },
  { name: 'Albert Lea' },
  { name: 'Red Wing' },
  { name: 'Faribault' },
  { name: 'Northfield' },
  { name: 'Lake City' },
  { name: 'Pine Island' },
  { name: 'and more' },
];

export const cityPages: CityPageData[] = [
  {
    slug: 'twin-cities',
    name: 'Twin Cities',
    title: 'Web Development, Branding, and App Development in the Twin Cities',
    intro:
      'ThirtyFive Studio handles web development, branding, app development, and more for businesses across Minneapolis, St. Paul, and the rest of the Twin Cities. We are based in Rochester, MN. We come to your office, and we also work remotely.',
  },
  {
    slug: 'rochester',
    name: 'Rochester',
    title: 'Web Development, Branding, and App Development in Rochester, MN',
    intro:
      'ThirtyFive Studio is based in Rochester, MN. We handle web development, branding, app development, and more for local businesses, and we meet you at your location.',
  },
  {
    slug: 'minneapolis',
    name: 'Minneapolis',
    title: 'Web Development, Branding, and App Development in Minneapolis, MN',
    intro:
      'ThirtyFive Studio handles web development, branding, app development, and more for Minneapolis businesses. We come to you in the city, and we also work remotely from our studio in Rochester, MN.',
  },
  {
    slug: 'st-paul',
    name: 'St. Paul',
    title: 'Web Development, Branding, and App Development in St. Paul, MN',
    intro:
      'ThirtyFive Studio handles web development, branding, app development, and more for St. Paul businesses. We meet you at your location, and we also work remotely from Rochester, MN.',
  },
  {
    slug: 'st-cloud',
    name: 'St. Cloud',
    title: 'Web Development, Branding, and App Development in St. Cloud, MN',
    intro:
      'ThirtyFive Studio handles web development, branding, app development, and more for St. Cloud businesses, including care providers. We come to you in St. Cloud, and we also work remotely from Rochester, MN.',
  },
  {
    slug: 'golden-valley',
    name: 'Golden Valley',
    title: 'Web Development, Branding, and App Development in Golden Valley, MN',
    intro:
      'ThirtyFive Studio handles web development, branding, app development, and more for Golden Valley businesses, including home care. We meet you there, and we also work remotely from Rochester, MN.',
  },
];

export const studioAnswers = [
  {
    question: 'Where is ThirtyFive Studio located?',
    answer:
      'ThirtyFive Studio is based in Rochester, MN. We meet clients at their business across the Twin Cities and southeast Minnesota, and we also work remotely.',
  },
  {
    question: 'What does ThirtyFive Studio do?',
    answer:
      'ThirtyFive Studio handles web development, branding, app development, and ongoing website updates.',
  },
  {
    question: 'Do you work in the Twin Cities?',
    answer:
      'Yes. We come to businesses in Minneapolis, St. Paul, and the rest of the Twin Cities, and we also work remotely from Rochester, MN.',
  },
];

export const locationAnswers = [
  {
    question: 'Who do you work with in this city?',
    answer:
      'We work with local businesses that need web development, branding, app development, marketing, or ongoing updates. We come to your location, and we also work remotely.',
  },
  {
    question: 'Do you have an office here?',
    answer:
      'Our studio is in Rochester, MN. We do not keep a separate office in every city. We meet clients at their business.',
  },
];
